import fullAr from './full/locales/ar.json' with { type: 'json' };
import fullEn from './full/locales/en.json' with { type: 'json' };
import fullEs from './full/locales/es.json' with { type: 'json' };
import fullPtBR from './full/locales/pt-BR.json' with { type: 'json' };
import type { Catalog, Locale } from './i18n';
import type { ClassTint } from './palette';

// Keys become palette tokens, so this stays a literal; the demo swaps in `full.demo.ts` (ADR 0015).
export const FULL_TINTS = {
  sportif: { crepuscule: '#5aa2ff', nuit: '#5aa2ff', aube: '#1a5296', jour: '#1d5ca6' },
  tatoue: { crepuscule: '#8d86ff', nuit: '#8d86ff', aube: '#463cb8', jour: '#4b42c2' },
  superfan: { crepuscule: '#c77dff', nuit: '#c77dff', aube: '#6e2fa6', jour: '#7834b4' },
  enracine: { crepuscule: '#8fd16a', nuit: '#8fd16a', aube: '#2a6119', jour: '#2e6a1b' },
  veilleur: { crepuscule: '#4fc6a0', nuit: '#4fc6a0', aube: '#1f5f4b', jour: '#226852' },
  celeste: { crepuscule: '#7f9cff', nuit: '#7f9cff', aube: '#2d4bb0', jour: '#3150bc' },
  babacool: { crepuscule: '#f2a65a', nuit: '#f2a65a', aube: '#8a4510', jour: '#964b12' },
  poussin: { crepuscule: '#ffe14d', nuit: '#ffe14d', aube: '#645600', jour: '#6e5e00' },
  avatar: { crepuscule: '#ff9a5a', nuit: '#ff9a5a', aube: '#8a3f12', jour: '#963f0e' },
  jongleur: { crepuscule: '#f7c948', nuit: '#f7c948', aube: '#6e5000', jour: '#7a5800' },
  circadien: { crepuscule: '#ffc14d', nuit: '#ffc14d', aube: '#6e4a00', jour: '#7a5200' },
} satisfies Readonly<Record<string, ClassTint>>;

export const FULL_CATALOGS: Readonly<Partial<Record<Locale, Catalog>>> = {
  en: fullEn,
  es: fullEs,
  'pt-BR': fullPtBR,
  ar: fullAr,
};
